import { ItemSetProvider } from '@exam-management/common/item-set-provider';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  ItemSetQuestionDetailHeader,
  ItemSetQuestionEditForm,
} from '@exam-management/qcontent-detail';
import { useParams } from '@exam-management/router';
import { Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ItemSetDetailLayout() {
  const { questionId } = useParams('/qbank-structures/:structureId/qcontents/item-set/:questionId');
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.QBANK.QUESTION.VIEW}>
      <ItemSetProvider itemSetId={questionId}>
        <ItemSetQuestionEditForm>
          <ItemSetQuestionDetailHeader />
          <Box>
            <Outlet />
          </Box>
        </ItemSetQuestionEditForm>
      </ItemSetProvider>
    </PermissionGuard>
  );
}
